




































import { IEventUIDto } from "@/lib/dto/event/event-ui.dto";
import { IVehicle } from "@/models/caseEntity";
import { ITicket } from "@/models/ticket.entity";
import { MrfiktivReportViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import Component from "vue-class-component";
import { Prop, Ref, Vue } from "vue-property-decorator";
import RefsCost from "./RefsCost.vue";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import { RefTypeMap } from "@/store/modules/refs.store";
import RefsAppraisal from "./RefsAppraisal.vue";
import RefsAttachmentRequest from "./RefsAttachmentRequest.vue";
import RefsClearance from "./RefsClearance.vue";
import RefsClearanceApproval from "./RefsClearanceApproval.vue";
import RefsCompany from "./RefsCompany.vue";
import RefsCompanyAddress from "./RefsCompanyAddress.vue";
import RefsCompanyGroup from "./RefsCompanyGroup.vue";
import RefsContract from "./RefsContract.vue";
import RefsCostGroup from "./RefsCostGroup.vue";
import RefsDocument from "./RefsDocument.vue";
import RefsEvent from "./RefsEvent.vue";
import RefsFleet from "./RefsFleet.vue";
import RefsGroup from "./RefsGroup.vue";
import RefsHandover from "./RefsHandover.vue";
import RefsMessage from "./RefsMessage.vue";
import RefsPartnerBanking from "./RefsPartnerBanking.vue";
import RefsPerson from "./RefsPerson.vue";
import RefsPersonEmail from "./RefsPersonEmail.vue";
import RefsPersonGroup from "./RefsPersonGroup.vue";
import RefsPersonPhone from "./RefsPersonPhone.vue";
import RefsRental from "./RefsRental.vue";
import RefsRepairEstimate from "./RefsRepairEstimate.vue";
import RefsReport from "./RefsReport.vue";
import RefsSignRequest from "./RefsSignRequest.vue";
import RefsSnapshot from "./RefsSnapshot.vue";
import RefsSnapshotSignRequest from "./RefsSnapshotSignRequest.vue";
import RefsTicket from "./RefsTicket.vue";
import RefsVehicle from "./RefsVehicle.vue";
import RefsReportGroup from "./RefsReportGroup.vue";
import { VSkeletonLoader } from "vuetify/lib";
import RefsVideo from "./RefsVideo.vue";
import RefsCustomerAccount from "./RefsCustomerAccount.vue";
import RefsLead from "./RefsLead.vue";

export interface IRefBase<T> {
  /**
   * The ref to be displayed.
   */
  item: T;

  /**
   * Displays the ref with less details.
   */
  small: boolean;

  /**
   * Indicates wether the ref should be displayed as confirmable.
   */
  confirmable: boolean;
}

export interface IRefDetail<T> extends IRefBase<T> {
  /**
   * Navigates to the detail page of the ref.
   */
  goToDetail: (newTab?: boolean) => void;
}

type ItemTypes = MrfiktivReportViewModelGen | IVehicle | IEventUIDto | ITicket;

const RefsInvoice = () => ({
  component: import("./RefsInvoice.vue"),
  loading: VSkeletonLoader
});

@Component({
  components: {
    RefsReport,
    RefsReportGroup,
    RefsVehicle,
    RefsEvent,
    RefsTicket,
    RefsDocument,
    RefsCost,
    RefsSignRequest,
    RefsAttachmentRequest,
    RefsCostGroup,
    RefsSnapshot,
    RefsSnapshotSignRequest,
    RefsHandover,
    RefsMessage,
    RefsCompany,
    RefsCompanyGroup,
    RefsPerson,
    RefsPersonGroup,
    RefsPersonPhone,
    RefsPersonEmail,
    RefsCompanyAddress,
    RefsGroup,
    RefsContract,
    RefsFleet,
    RefsPartnerBanking,
    RefsRepairEstimate,
    RefsClearanceApproval,
    RefsClearance,
    RefsRental,
    RefsAppraisal,
    RefsInvoice,
    RefsVideo,
    RefsLead,
    RefsCustomerAccount,
    LatestEntriesCardEmpty
  }
})
export default class RefsList extends Vue implements IRefDetail<ItemTypes> {
  @Prop()
  item!: ItemTypes;

  @Prop()
  itemPromise?: () => Promise<ItemTypes>;

  @Prop()
  refType!: ResourceEnum;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  @Ref("refDetail")
  refDetail!: IRefDetail<ItemTypes>;

  loading = false;

  loadedItem: ItemTypes | null = null;

  readonly ResourceEnum = ResourceEnum;

  get refComponentName(): string | null {
    return RefTypeMap.get(this.refType)?.component || null;
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail(v: any) {
    this.$emit("openDetail", v);
  }

  goToDetail() {
    this.refDetail?.goToDetail();
  }

  async mounted() {
    if (!this.itemPromise) {
      return;
    }
    try {
      this.loading = true;
      const item = await this.itemPromise();
      this.loadedItem = item;
      this.loading = false;
    } catch (e) {
      this.$log.error(e);
    }
  }
}
